import './Block.css'

function Block({ block, onClick }) {
    return (
        <div className={`block 
            ${block.isBlack ? "black" : "white"}
            ${block.highlighted ? "glow" : ""} 
        `} onClick={onClick}>
            {/* <p>{block.id}</p> */}
        </div>
    )
}

export default Block;